import type { HTMLAttributes, Ref } from 'vue'
import type { ElementPosition } from '@gat-ship/utils'
import type { IconValues } from '@gat-ship/icons'
import type { GatRouteLocation, AppRoute } from '@gat-ship/lib/router'
import { createContext } from 'reka-ui'
export { default as GatTab } from './gat-tab.vue'
export * from './gat-tab.vue'
export { default as GatTabItem } from './gat-tab-item.vue'
export * from './gat-tab-item.vue'

export interface TabItem {
  /** The text of the tab. */
  text: string
  /** The icon of the tab. */
  icon?: IconValues
  /** The route to the tab. */
  to?: GatRouteLocation<AppRoute>
  /** The value of the tab. This is the value that is used to set the active tab. */
  value: string
  /** The class of the tab. */
  class?: HTMLAttributes['class']
  /** The data test id of the tab. */
  dataTestid?: string
  /** Whether the tab is disabled. */
  disabled?: boolean
  /** The count of the tab. */
  count?: number
}

export type GatTabContext = {
  modelValue: Ref<string | undefined>
  activeTab: Ref<string | undefined>
}

export const [useGatTab, provideGatTab] =
  createContext<GatTabContext>('gat-tab')
